module.exports = __webpack_public_path__ + "images/light-8080d6b0f48b680ad45accaffef52d56.jpg";